const { corePageContent } = require('./content/core');
const { supportPageContent } = require('./content/support');

const yowanPageContent = Object.assign({}, corePageContent, supportPageContent);

module.exports = yowanPageContent;
module.exports.yowanPageContent = yowanPageContent;
